<a class="linkContainer center" fxLayout="row" (click)="navToLink()">
    <div>
        <mat-icon>{{icon}}</mat-icon>
    </div>
    <div fxLayout="column">
        <div class="heading">{{label}}</div>
        <div class="description">{{description}}</div>
    </div>
</a>